import './instrument'
import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react';

import '@fontsource/inter'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'

import 'react-edit-text/dist/index.css'
import App from './App'
import './style-new.css'
import './style.css'

ReactDOM.createRoot(
    document.getElementById('root')!,
    {
      // Callback called when an error is thrown and not caught by an ErrorBoundary.
      onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
      }),
      // Callback called when React catches an error in an ErrorBoundary.
      onCaughtError: Sentry.reactErrorHandler(),
      // Callback called when React automatically recovers from errors.
      onRecoverableError: Sentry.reactErrorHandler(),
    }
).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
)
